// The Kit's tokens, then its compiled primitives, then the host's own CSS
// (`@/styles/globals.css`, below): the order the Kit README requires, so a
// host utility passed through `className` wins over a Kit one at equal
// specificity, by source order. A Kit variant or state selector of higher
// specificity (`fsui-hover:…`, `fsui-data-[state=open]:…`) still wins.
import "@attmos/flowstack-ui/tokens.css";
import "@attmos/flowstack-ui/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App";
import { retryQuery } from "@/api/retry";
import "@/styles/fonts.css";
import "@/styles/globals.css";
import { applyDensityAttr, useDensityStore } from "@/stores/density";
import { applyThemeClass, useThemeStore } from "@/stores/theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // `@/api/retry` holds the policy and the reasoning; it is exported
      // because a fan-out that depends on "a 403 is not retried" should be
      // able to state that at the fan-out rather than inherit it from here.
      retry: retryQuery,
    },
  },
});

applyThemeClass(useThemeStore.getState().theme);
applyDensityAttr(useDensityStore.getState().density);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("FlowStack webapp could not find a #root element to mount on.");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
